package fr.frux.feature.harvestcreate

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.FilterChip
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import fr.frux.core.designsystem.theme.FruxSpacing
import fr.frux.feature.harvestcreate.resources.Res
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_hints_title
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_hosted_hint
import fr.frux.feature.harvestcreate.resources.harvestcreate_site_hosted_title
import org.jetbrains.compose.resources.stringResource

/** Interrupteur « Chez moi, je vous invite » du propriétaire d'un lieu (ADR 0035). */
@Composable
internal fun HostedByOwnerSwitch(
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = MaterialTheme.shapes.large,
        color = MaterialTheme.colorScheme.secondaryContainer,
    ) {
        Row(
            modifier = Modifier.padding(FruxSpacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(FruxSpacing.md),
        ) {
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(FruxSpacing.xs)) {
                Text(
                    text = stringResource(Res.string.harvestcreate_site_hosted_title),
                    style = MaterialTheme.typography.titleSmall,
                )
                Text(
                    text = stringResource(Res.string.harvestcreate_site_hosted_hint),
                    style = MaterialTheme.typography.bodySmall,
                )
            }
            Switch(checked = checked, onCheckedChange = onCheckedChange)
        }
    }
}

/** Chips de consignes, affichées seulement quand l'hôte accueille chez lui. Une chip ne s'ajoute qu'une fois. */
@Composable
internal fun AccessHintChips(
    applied: Set<AccessHint>,
    onHintClicked: (AccessHint, String) -> Unit,
) {
    Column(verticalArrangement = Arrangement.spacedBy(FruxSpacing.xs)) {
        Text(stringResource(Res.string.harvestcreate_site_hints_title), style = MaterialTheme.typography.titleSmall)
        FlowRow(horizontalArrangement = Arrangement.spacedBy(FruxSpacing.xs)) {
            AccessHint.entries.forEach { hint ->
                val sentence = stringResource(hint.textRes)
                FilterChip(
                    selected = hint in applied,
                    onClick = { onHintClicked(hint, sentence) },
                    enabled = hint !in applied,
                    label = { Text(sentence) },
                )
            }
        }
    }
}
